import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { authApi } from "@/lib/api";
import { toast } from "sonner";
import { AUTH } from "@/constants/testIds";

export function VerifyBanner() {
  const { user, emailVerified } = useAuth();
  if (!user || emailVerified) return null;

  const resend = async () => {
    try {
      await authApi.resendVerification(user.email);
      toast.success("Wysłaliśmy nową wiadomość weryfikacyjną (sprawdź pocztę).");
    } catch (e) {
      if (e?.response?.status === 429) {
        const ra = Number(e?.response?.headers?.["retry-after"]);
        const mins = ra ? Math.max(1, Math.ceil(ra / 60)) : null;
        toast.error(mins
          ? `Osiągnięto limit wysyłek. Spróbuj ponownie za ${mins} min.`
          : "Osiągnięto limit wysyłek. Spróbuj ponownie później.");
      } else {
        toast.error("Nie udało się wysłać wiadomości. Spróbuj ponownie.");
      }
    }
  };

  return (
    <div
      data-testid={AUTH.verifyBanner}
      className="mb-6 flex flex-col gap-2 rounded-card border border-brand-line bg-brand-surface px-4 py-3 text-sm text-brand-sec sm:flex-row sm:items-center sm:justify-between"
    >
      <span>
        Wszystkie funkcje są już dostępne. Potwierdź e-mail, aby zabezpieczyć konto i umożliwić odzyskiwanie hasła oraz ważne powiadomienia (np. o kredytach i płatnościach).
      </span>
      <button
        type="button"
        data-testid={AUTH.resendVerificationButton}
        onClick={resend}
        className="self-start font-medium text-brand-accent hover:underline sm:self-auto"
      >
        Wyślij ponownie link
      </button>
    </div>
  );
}

export default VerifyBanner;
